import * as React from 'react'

import {IconProps} from '.'

function ServicesAdmin({color, size, isFilled}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={isFilled ? color : 'none'}
      xmlns="http://www.w3.org/2000/svg">
      {/* Gear icon consistent with stroke style */}
      <path
        d="M12 15.5C13.933 15.5 15.5 13.933 15.5 12C15.5 10.067 13.933 8.5 12 8.5C10.067 8.5 8.5 10.067 8.5 12C8.5 13.933 10.067 15.5 12 15.5Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.75 12C4.75 11.59 4.79 11.19 4.87 10.8L3.2 9.7L4.3 7.7L6.19 8.17C6.61 7.62 7.11 7.14 7.68 6.76L7.5 4.75H9.75L10.15 6.6C10.77 6.46 11.38 6.46 12 6.6L12.4 4.75H14.65L14.47 6.76C15.04 7.14 15.54 7.62 15.96 8.17L17.85 7.7L18.95 9.7L17.28 10.8C17.36 11.19 17.4 11.59 17.4 12C17.4 12.41 17.36 12.81 17.28 13.2L18.95 14.3L17.85 16.3L15.96 15.83C15.54 16.38 15.04 16.86 14.47 17.24L14.65 19.25H12.4L12 17.4C11.38 17.54 10.77 17.54 10.15 17.4L9.75 19.25H7.5L7.68 17.24C7.11 16.86 6.61 16.38 6.19 15.83L4.3 16.3L3.2 14.3L4.87 13.2C4.79 12.81 4.75 12.41 4.75 12Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default ServicesAdmin
